module.exports = __webpack_public_path__ + "img/spd-logo.958439f0.svg";